// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup-backdrop[data-v-453144f8]{position:fixed;top:0;bottom:0;left:0;right:0;z-index:9999;background-color:#000;opacity:.5;transition:opacity .15s linear}", ""]);
// Exports
module.exports = exports;
